<template>
  <div>
    <template v-for="(item, $index) in ruleList">
      <div class="panel-box" :key="$index + '_1'">
        <slot></slot>
        <RuleDigitalEditListTypeItem
          ref="RuleDigitalEditListTypeItem"
          :ruleTypeItem="item"
          :ruleTypeItemIndex="$index"
        />
      </div>
      <div class="eb-line" :key="$index + '_2'"></div>
    </template>
    <RuleDigitalTypeAddDialog :isVisible.sync="isRuleTypeAddVisible" :ruleType="ruleType"/>
    <RuleDigitalTypeEditDialog :isVisible.sync="isRuleTypeEditVisible" :ruleType="ruleType"/>
    <RuleDigitalEditDialog
      :isVisible.sync="isRuleDigitalEditVisible"
      :operType="ruleDigitalOperType"
      :ruleDigital="ruleDigital"
    />
  </div>
</template>

<script>
import RuleDigitalEditListTypeItem from '@/components/ruletemplate/edit/RuleDigitalEditListTypeItem';

export default {
  provide() {
    return {
      showAddRuleTypeDialog: this.showAddRuleTypeDialog,
      showEditRuleTypeDialog: this.showEditRuleTypeDialog,
      showAddDigitalDialog: this.showAddDigitalDialog,
      showEditDigitalDialog: this.showEditDigitalDialog
    };
  },
  components: {
    RuleDigitalEditListTypeItem,
    RuleDigitalTypeEditDialog: () => import('./RuleDigitalTypeEditDialog'),
    RuleDigitalEditDialog: () => import('./RuleDigitalEditDialog'),
    RuleDigitalTypeAddDialog: () => import('./RuleDigitalTypeAddDialog')
  },
  props: {
    ruleList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isRuleTypeAddVisible: false,
      isRuleTypeEditVisible: false,
      isRuleDigitalEditVisible: false,
      ruleDigitalOperType: '',
      ruleType: {
        templateId: null,
        typeName: null,
        newTypeName: null
      },
      ruleDigital: {
        digitalId: null,
        typeName: null,
        ruleName: null,
        ruleContent: null,
        ruleResult: null,
        ruleType: null,
        templateId: null
      }
    };
  },
  created() {},
  methods: {
    expandAll() {
      this.$refs.RuleDigitalEditListTypeItem.forEach(function(item) {
        item.isExpand = true;
      });
    },
    collapseAll() {
      this.$refs.RuleDigitalEditListTypeItem.forEach(function(item) {
        item.isExpand = false;
      });
    },
    showAddRuleTypeDialog(templateId) {
      this.isRuleTypeAddVisible = true;
      this.ruleType.templateId = templateId;
      this.ruleType.typeName = null;
      this.ruleType.newTypeName = null;
    },
    showEditRuleTypeDialog(templateId, typeName) {
      this.isRuleTypeEditVisible = true;
      this.ruleType.templateId = templateId;
      this.ruleType.typeName = typeName;
      this.ruleType.newTypeName = null;
    },
    showAddDigitalDialog(templateId, typeName, groupSort) {
      this.resetRuleDigital();
      this.ruleDigital.templateId = templateId;
      this.ruleDigital.typeName = typeName;
      this.ruleDigital.ruleContent = [{ type: 'images', content: '' }];
      this.ruleDigital.groupSort = groupSort;

      this.ruleDigitalOperType = 'add';
      this.isRuleDigitalEditVisible = true;
    },
    showEditDigitalDialog(ruleDigital) {
      // 重置
      this.resetRuleDigital();
      // 赋值
      // Object.keys(this.ruleDigital).forEach(item => {
      //   this.ruleDigital[item] = ruleDigital[item];
      // });
      this.ruleDigital.digitalId = ruleDigital.digitalId;
      this.ruleDigital.ruleName = ruleDigital.ruleName;
      this.ruleDigital.ruleContent = ruleDigital.ruleContent;
      this.ruleDigital.ruleType = ruleDigital.ruleType;

      this.ruleDigitalOperType = 'edit';
      // 显示窗口
      this.isRuleDigitalEditVisible = true;
    },
    resetRuleDigital() {
      Object.keys(this.ruleDigital).forEach(item => {
        this.ruleDigital[item] = null;
      });
    }
  }
};
</script>

<style>
</style>
